export const showAudioModal = (openModal: any) => ({
    type: 'showAudioModal',
    openModal: openModal,
});

export const resetAudioModal = () => ({
    type: 'resetAudioModal',
});
